import { render } from "./AppFooter.vue?vue&type=template&id=b5454f9e&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=b5454f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5454f9e"]])

export default __exports__